import Block from 'pages/block-card/ui/BlockCardPage';

const BlockCardPage = () => <Block />;

export default BlockCardPage; 